/**
 * 통로등 테스트 — 실제로 지나가면서 CCTV 마다 통로등이 밝아지는지 확인한다. 점유는 바꾸지 않는다.
 * 반응한 CCTV 는 맵의 점이 파랗게 바뀌고, 여기는 반응 수 바 하나만 둔다 — 어느 CCTV 가 남았는지는
 * 맵의 점 색으로 보면 된다.
 */
import React from 'react';
import { Box, Button, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { RestartAlt as ResetIcon } from '@mui/icons-material';

import type { AisleWatch } from './qaAisle';
import { MARK_COLOR } from './QaSiteMap';

interface Props {
  watch: AisleWatch;
  /** 조명을 아직 못 읽었거나 조명 서비스가 없을 때 그 사유. */
  unavailable?: string;
  onReset: () => void;
}

const QaAislePanel: React.FC<Props> = ({ watch, unavailable, onReset }) => {
  const names = Object.keys(watch.cctvs);
  const done = names.filter((n) => watch.cctvs[n].reactedAt !== undefined);
  return (
    <Paper
      variant="outlined"
      sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 2 }}
      data-testid="qa-aisle"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="subtitle1" fontWeight={700} sx={{ mr: 'auto' }}>
          통로등 반응 확인
        </Typography>
        <Button size="small" startIcon={<ResetIcon />} onClick={onReset} disabled={!names.length}>
          처음부터
        </Button>
      </Stack>
      <Typography variant="caption" color="text.secondary" component="p">
        CCTV 앞을 지나가면 그 CCTV 의 통로등이 밝아져야 합니다. 평소보다 밝아진 CCTV 는 맵에서
        <Box component="span" sx={{ color: MARK_COLOR, fontWeight: 700 }}>
          {' '}
          파란 점
        </Box>
        으로 바뀝니다.
      </Typography>
      {unavailable ? (
        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
          {unavailable}
        </Typography>
      ) : (
        <>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1.5 }}>
            <Typography variant="body2" fontWeight={700} data-testid="qa-aisle-progress">
              반응 {done.length} / {names.length} CCTV
            </Typography>
            <LinearProgress
              variant="determinate"
              value={names.length ? (done.length * 100) / names.length : 0}
              sx={{ flex: 1, height: 6, borderRadius: 3 }}
            />
          </Stack>
        </>
      )}
    </Paper>
  );
};

export default QaAislePanel;
